import React from 'react';
import './FailedSanctions.scss';
export const FailedSanctions = ({ adults, children }) => {
  const travellers = adults.concat(children);
  const failingTravellers = travellers.filter(
    (traveller) => traveller?.sanctions_check?.result,
  );
  if (!failingTravellers.length) {
    return null;
  }

  return (
    <div className="error-box sanction-error-box">
      <h4>Sanction check failed:</h4>
      {failingTravellers.map((traveller, index) => {
        return (
          <p key={index}>
            {index + 1}: {traveller.first_name} {traveller.last_name} (sanction ID:{' '}
            {traveller.sanction_id})
          </p>
        );
      })}
    </div>
  );
};
